import React from "react";
import MainDescription from "./MainDescription/AboutMainDescription";

const AboutMain = () => {
  return (
    <div className="__sweven_about-main">
      <MainDescription />
    </div>
  );
};

export default AboutMain;
